// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__3oRBd","infoContainer":"About_infoContainer__3YQwD","section":"About_section__OwNKl"};